// extracted by mini-css-extract-plugin
export var active = "_83-1";
export var activeSubdued = "_83-2";
export var compact = "_83-3";
export var fill = "_83-6";
export var pulse = "_83-4";
export var settingHighlightPulse = "_83-5";
export var wrapper = "_83-0";